import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
} from "react-admin";
import GlobalPagination from "../common/GlobalPagination";

import mailAccountFilters from "./mailAccountFilters";

const MailAccountList = () => (
  <List
    sort={{ field: "emailAddress", order: "ASC" }}
    filters={mailAccountFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
  >
    <Datagrid rowClick="edit">
      <TextField source="emailAddress" />
      <TextField source="username" />
      <ReferenceField
        source="domainId"
        reference="Domain"
        sortable={false}
        link="show"
      >
        <TextField source="unicodeName" />
      </ReferenceField>
      <ReferenceField
        source="customerId"
        reference="Customer"
        sortable={false}
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
export default MailAccountList;
